import { Edit } from '@mui/icons-material'
import { IconButton } from '@mui/material'

interface EditActionButtonProps {
  onClick: () => void
}

const EditActionButton = ({ onClick }: EditActionButtonProps) => {
  return (
    <IconButton color={'primary'} aria-label="Edit" onClick={onClick}>
      <Edit />
    </IconButton>
  )
}

export default EditActionButton
